import { render } from "./SubscriptionList.vue?vue&type=template&id=d8083a5c"
import script from "./SubscriptionList.vue?vue&type=script&lang=js"
export * from "./SubscriptionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__